<template>
    <div class="widget" :class="{ 'is-loading': isLoading }">
        <div class="widget__inner" style="padding: 35px 30px;">
            <p>{{ diskUsage.amounts.used | formatNumber(1) }} GB van {{ diskUsage.amounts.total | formatNumber(1) }} GB gebruikt.</p>
            <div class="usage">
                <div class="usage__inner" :style="{ width: diskUsage.percentages.used + '%' }"><span v-show=" diskUsage.percentages.used > 40">{{ diskUsage.percentages.used | formatNumber(1) }}% gebruikt</span></div>
            </div>
        </div>
    </div>
</template>

<script>
	import { mapGetters } from 'vuex'
	import { FETCH_DISK_USAGE } from '@/store/modules/widgets'

	export default {
		data () {
			return {
				isLoading: true,
			}
		},

		computed: {
			...mapGetters([
				'diskUsage',
			]),
		},

		mounted () {
			this.fetchData()
		},

		methods: {
			fetchData () {
				this.$store.dispatch(FETCH_DISK_USAGE).then(() => {
					this.isLoading = false
				})
			},
		},
	}
</script>